// Tahsis-aligned brand tokens — single navy palette for all roles
const TAHSIS_TOKENS = {
  primary: '#24299d',
  primaryLight: '#3840c4',
  primaryDark: '#1b2080',
  contrastText: '#ffffff',
  gradient: 'linear-gradient(135deg, #24299d 0%, #3840c4 100%)',
  gradientHover: 'linear-gradient(135deg, #1b2080 0%, #24299d 100%)',
  softBg: 'rgba(36, 41, 157, 0.08)',
  softBgHover: 'rgba(36, 41, 157, 0.15)',
  softBgStrong: 'rgba(36, 41, 157, 0.25)',
  outline: 'rgba(36, 41, 157, 0.35)',
  badge: '#24299d',
};

export const getRoleColors = () => TAHSIS_TOKENS;

export default getRoleColors;
